import { Button, Calendar, Select, Tag, Tooltip } from 'kenshin';
import { Popover } from 'antd';
import { memo, useMemo, useState } from 'react';
import {
  ExclamationCircleFilled,
  CheckCircleFilled,
  RightOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { useCreation, useMemoizedFn } from 'ahooks';
import { useDispatch, history } from 'umi';
import styles from './styles.less';
import './styles.less';
import {
  LateIcon,
  OverTimeIcon,
  VavationApplyIcon,
  GooutIcon,
  LeaveEarlyIcon,
  AwardIcon,
  SummaryIcon,
  HighTeaIcon,
  BirthdayIcon,
} from './util/icon';
import IconReport from '@/_assets/icon-report.png';
import { getIconTootlip } from './util/data';

const WorkCalendar = memo(({ data, homeHoliday }) => {
  const [calendarTime, setCalendarTime] = useState(moment());
  const [showModal, setShowModal] = useState(false);

  // 以日期为key值的对象，{'时间戳':数据}
  const dateObj = useMemo(() => {
    console.log('日子。。。', data);

    let obj = {};
    data.map((item) => {
      let key = +moment(item.reportDate);
      obj[key] = item;
    });
    return obj;
  }, [data]);

  const dispatch = useDispatch();

  // 面板变化时请求当月数据
  const getCurDateData = (date) => {
    setCalendarTime(moment(date));
    dispatch({
      type: 'usercenter/getEmpWorkRptList',
      payload: {
        empIdString: localStorage.getItem('muId'),
        rptBeginTime: moment(date)
          .subtract(1, 'M')
          .startOf('M')
          .format('YYYY-MM-DD'),
        rptEndTime: moment(date).endOf('M').format('YYYY-MM-DD'),
      },
    });
  };

  const toRptAudit = (date) => {
    history.push({
      pathname: '/usercenter/rptAudit',
      query: {
        reportDate: date,
      },
    });
  };

  const renderProjectPop = (data) => {
    return data?.rptProServCatgList
      ?.sort((a, b) => a.workBeginTime - b.workBeginTime)
      .map((item, i) => {
        return (
          <div key={i}>
            {moment(item.workBeginTime).format('HH:mm:ss')} ~{' '}
            {moment(item.workEndTime).format('HH:mm:ss')}
            {'  '}
            {item.projectName}
            {'>'}
            {item.servCatgName}
            {'>'}
            {item.taskName}
            {' ： '}
            {item.rptRemark}
          </div>
        );
      });
  };

  // 抽取样式逻辑到函数
  const getActivityStyle = (item) => {
    let baseStyle = {
      display: 'flex',
      justifyContent: 'center',
      width: '90%',
      height: 'auto',
      alignItems: 'center',
      borderRadius: '4px',
      padding: '0 4px',
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
    };

    if (item.includes('总结') || item.includes('颁奖')) {
      return {
        ...baseStyle,
        backgroundColor: 'rgba(254, 152, 0, 0.2)',
        color: '#FFA51E',
      };
    } else if (item.includes('生日') || item.includes('下午')) {
      return {
        ...baseStyle,
        backgroundColor: 'rgba(231, 180, 255, 0.3)',
        color: '#B269D5',
      };
    } else if (item.includes('工作包')) {
      return {
        ...baseStyle,
        backgroundColor: 'rgba(51, 194, 143, 0.1)',
        color: '#33C28F',
      };
    }
    return {
      ...baseStyle,
      backgroundColor: 'rgba(255, 73, 73, 0.1)',
      color: '#F95520',
      border: '1px solid rgba(255, 73, 73, 0.2)',
      border: 'none',
    };
  };

  const renderPopContent = (datas) => {
    // console.log('renderPopContent...', datas);
    return (
      <div className="popoverContentMain">
        {datas.child.map((item, i) => {
          return (
            <div key={i} className="popoverContentItem" style={{}}>
              <p className="text">{item}</p>
              <p className="time">
                <span></span>
                {datas.startDate[i]} ~ {datas.endDate[i]}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  /** 日历面包下的图标 */
  const renderDateIcon = (data) => {
    if (!data) return null;
    let {
      goout,
      overtime,
      late,
      leaveEarly,
      vacationApply,
      iconAward,
      iconSummary,
      iconHighTea,
      iconBirthday,
      showText,
    } = data;
    // console.log('renderDateIcon...', data);
    // goout = true;
    // overtime = true;
    // vacationApply = true;
    // late = true
    // iconAward = true
    // iconSummary = true
    // iconHighTea = true;
    // iconBirthday = true
    const iconDesc = [
      [goout, GooutIcon, true],
      [overtime, OverTimeIcon, true],
      [late, LateIcon, true],
      [leaveEarly, LeaveEarlyIcon, true],
      [vacationApply, VavationApplyIcon, true],
      [iconAward, AwardIcon],
      [iconSummary, SummaryIcon],
      [iconHighTea, HighTeaIcon],
      [iconBirthday, BirthdayIcon],
    ].map(([icon, name, showTooltip], i) => {
      if (icon) {
        return showTooltip ? (
          <Tooltip
            title={getIconTootlip(data)}
          overlayStyle={{
            color: '#333',
            fontSize: 12,
            lineHeight: '24px',
          }}
          color="#fff"
          key={i}
        >
          <div >{name}</div>
        </Tooltip>): <div key={i}>{name}</div>;

        // return <div key={i}>{name}</div>;
      }
      return null;
    });

    // return iconDesc.filter(Boolean);
    return iconDesc.filter(Boolean).slice(0, showText ? 2 : 4);
  };

  const dateRender = (date, dateToday) => {
    const [showText, setShowText] = useState(false);
    /** 渲染是否上报信息的icon */
    const renderIsRptIcon = () => {
      if (date < moment()) {
        if (curData?.rptProServCatgList) return <CheckCircleFilled />;
        if (hasShowicon()) return <ExclamationCircleFilled />;
      }
      return null;
    };

    let curData = dateObj[+moment(date).startOf('date')]; // 当前日期是否有上报记录
    // console.log('dateRender1...', curData);
    if (
      homeHoliday &&
      curData &&
      homeHoliday[curData.reportDate] &&
      homeHoliday[curData.reportDate].child
    ) {
      let holidayData = homeHoliday[curData.reportDate];
      // 判断是否包含颁奖
      curData.iconAward = holidayData.child.some((item) =>
        typeof item === 'string' ? item.includes('颁奖') : false,
      );
      // 判断是否包含生日
      curData.iconBirthday = holidayData.child.some((item) =>
        typeof item === 'string' ? item.includes('生日') : false,
      );
      // 判断是否包含_highTea
      curData.iconHighTea = holidayData.child.some((item) =>
        typeof item === 'string' ? item.includes('下午茶') : false,
      );
      // 判断是否包含_summary
      curData.iconSummary = holidayData.child.some((item) =>
        typeof item === 'string' ? item.includes('总结') : false,
      );

      curData.showText = showText;

      // console.log('dateRender...', homeHoliday[curData.reportDate]);
    }
    let today = +moment(dateToday).startOf('date'); // 今天
    let dateStr = moment(date).format('YYYY-MM-DD'); // 时间年月格式
    let holidayOrNo = homeHoliday[dateStr]; // 节假日

    let hasShowicon = () => {
      if (holidayOrNo) {
        if (holidayOrNo.holiday) return false;
        return true;
      }
      if (moment(date).get('d') == 0 || moment(date).get('d') == 6)
        return false;
      return true;
    };

    let DataIcon = renderDateIcon(curData);
    return (
      <div
        className={`home-calendar ${!hasShowicon() ? 'reset-day' : ''}`}
        onMouseEnter={() => setShowText(true)}
        onMouseLeave={() => setShowText(false)}
      >
        <div className="date">{date.date()}</div>
        <div className="icon">
          {renderIsRptIcon()}
          {holidayOrNo && (
            <span className="holidayIcon">
              {holidayOrNo.holiday ? '休' : '班'}
            </span>
          )}
        </div>

        {curData?.rptProServCatgList && (
          <Tooltip
            title={
              curData?.rptProServCatgList ? renderProjectPop(curData) : null
            }
          >
            {/* <div style={{ width: '100%' }}> */}

            <div
              style={{
                ...getActivityStyle(
                  `${curData?.rptProServCatgNum}个工作包，${curData?.totalRptWorkHours}/时`,
                ),
              }}
            >
              <span>
                {curData?.rptProServCatgNum}个工作包，
                {curData?.totalRptWorkHours}/时
              </span>
            </div>

            {/* </div> */}
          </Tooltip>
        )}

        {holidayOrNo && (
          // <Tooltip
          //   title={holidayOrNo.name}
          // >
          //   <div style={{ width: '100%' }}>
          //     <Tag.MiniTag type="danger">
          //       {holidayOrNo.name}
          //     </Tag.MiniTag>
          //   </div>
          // </Tooltip>
          <div style={{ width: '100%' }}>
            {holidayOrNo.child && holidayOrNo.child.length >= 1 ? (
              (() => {
                // 控制显示的Tag数量
                const displayTagCount =
                  curData?.rptProServCatgList?.length > 0 ? 1 : 2;
                const filteredChild = holidayOrNo.child.filter((item) => item);
                const startDate = holidayOrNo.startDate.filter((item) => item);

                return (
                  <Popover
                    content={renderPopContent(holidayOrNo)}
                    title={holidayOrNo.date}
                    placement="bottomRight"
                    trigger="click"
                  >
                    <div
                      style={{ marginTop: '0px' }}
                      className="activities-container"
                    >
                      {/* 显示前N个Tag */}
                      {filteredChild
                        .slice(0, displayTagCount)
                        .map((item, index) => (
                          <div
                            key={index}
                            style={{
                              ...getActivityStyle(item),
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>{item}</span>
                            <span className="tag-time">{startDate[index]}</span>
                          </div>
                        ))}

                      {/* 如果超过N个，显示更多活动 */}
                      {filteredChild.length > displayTagCount && (
                        <div
                          style={{
                            ...getActivityStyle(
                              `更多活动(${filteredChild.length - displayTagCount
                              })`,
                            ),
                          }}
                        >
                          <span>
                            更多活动({filteredChild.length - displayTagCount})
                          </span>
                        </div>
                      )}
                    </div>
                  </Popover>
                );
              })()
            ) : (
              <div
                style={{
                  justifyContent: 'space-between',
                  ...getActivityStyle(holidayOrNo.name),
                  marginLeft: '5%',
                }}
              >
                <span>{holidayOrNo.name}</span>
              </div>
            )}
          </div>
        )}

        {date < moment().startOf('date') && (
          <Button
            className={`kenshin-button reportBtn ${showText ? 'hover' : ''}`}
            shape="simple"
            size="small"
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              toRptAudit(+date);
            }}
          >
            <img src={IconReport} alt="工作补报" />
            {showText && '工作补报'}
          </Button>
        )}
        {moment(date).startOf('date') == today && (
          <Button
            className={`kenshin-button reportBtn ${showText ? 'hover' : ''}`}
            size="small"
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              toRptAudit();
            }}
          >
            <img src={IconReport} alt="工作补报" />
            {showText && '今日上报'}
          </Button>
        )}

        <div className="data-icon-container">
          {DataIcon?.length > 0 && (
            // <Tooltip
            //   title={getIconTootlip(curData)}
            //   overlayStyle={{
            //     color: '#333',
            //     fontSize: 12,
            //     lineHeight: '24px',
            //   }}
            //   color="#fff"
            // >
            <div className="calendar-item-icon">{DataIcon}</div>
            // </Tooltip>
          )}
        </div>
      </div>
    );
  };

  const addCalendarTime = (diff, unit) => {
    if (diff == 0) {
      getCurDateData(moment());
    } else {
      getCurDateData(moment(calendarTime).add(diff, unit));
    }
  };

  /** 顶部描述 */
  const iconDesc = () => {
    return [
      [AwardIcon, '颁奖会', 'png'],
      [SummaryIcon, '总结会', 'png'],
      [HighTeaIcon, '下午茶', 'png'],
      [BirthdayIcon, '生日会', 'png'],
      [GooutIcon, '有外出'],
      [OverTimeIcon, '有加班'],
      [LateIcon, '有迟到'],
      [LeaveEarlyIcon, '有早退'],
      [VavationApplyIcon, '有请假'],
    ].map(([icon, name, type]) => {
      return (
        <div className="desc-item" key={name}>
          {/* {type == 'png' ? <img style={{ width: 22, height: 22 }} src={icon} alt={name} /> : icon} */}
          {icon}
          <span className="desc">{name}</span>
        </div>
      );
    });
  };

  const yearOptions = useCreation(() => {
    const currentYear = moment(calendarTime).year();
    const startYear = currentYear - 30;
    const endYear = currentYear + 30;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push({ label: year, value: year });
    }
    return years;
  }, [calendarTime]);

  const headerRender = () => {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'space-between' }}
        className="home-calendar-header"
      >
        <div className="home-card-title">工作日历</div>
        <div style={{ display: 'flex' }}>
          <div className="icon-desc-box">{iconDesc()}</div>
          <Select
            options={yearOptions}
            value={calendarTime.year()}
            style={{ width: 100, marginLeft: 10, height: 30 }}
            onChange={(val) =>
              getCurDateData(moment(calendarTime).set('year', val))
            }
          />
          <Select
            options={new Array(12)
              .fill('')
              .map((_, i) => ({ label: `${i + 1}月`, value: i }))}
            value={calendarTime.month()}
            style={{ width: 100, margin: '0 10px', height: 30 }}
            onChange={(val) =>
              getCurDateData(moment(calendarTime).set('month', val))
            }
          />
          <div
            className={styles.calenartBtn}
            onClick={() => addCalendarTime(-1, 'month')}
          >
            <LeftOutlined />
          </div>
          {/* <div className='flr' style={{ marginLeft: 10 }} onClick={() => addCalendarTime(0, "month")}>今天</div> */}
          <div
            className={styles.calenartBtn}
            onClick={() => addCalendarTime(1, 'month')}
          >
            <RightOutlined />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Calendar
      dateRender={dateRender}
      value={calendarTime}
      headerRender={headerRender}
      showToday={false}
      onPanelChange={getCurDateData}
      onChange={getCurDateData}
    />
  );
});

export default WorkCalendar;
